import { ValidationTranslation } from 'locales/de/validation';

/* eslint-disable */
const en: ValidationTranslation = {
  required: 'You have to fill in this field.',
  min: 'You have to select at least {{min}} item(s).',
  minCreateOne: 'You must create at least one entry.',
  minChars: 'You have to write at least {{min}} characters.',
  max: 'You may only provide up to {{max}} letters.',
  email: 'You have to provide a valid email address.',
  homepage: 'You have to provide a valid URL (starts with http(s)://).',
  passwordMatch: 'The passwords must match.',
  emailTaken: 'A user with this email address is already registered.',
  taxIdOrTaxNumber: 'VAT Reg No. or Tax Number is required.',
  taxNumberFormat: 'Tax number has the form FF(F)/BBB(B)/UU(U)P.',
  taxIdEuCountry: 'VAT Reg No. is required for EU-countries.',
  taxId: 'You have to provide a valid VAT Reg No.',
  taxIdForeign: 'Only for foreign companies',
  formHasErrors: 'The form is not yet complete or contains errors. Please check your input.',
  taxIdFormat:
    'The VAT ID is either too short or contains invalid special characters or whitespaces.',
  summerOrWinter: 'Winter or summer needs to be active.',
  minOne: 'At least one element must be selected.',
  endDateBeforeStartDate: 'The end date must not be set before the start date.',
  dischargeByStudentsUntilBeforeEndDate:
    'The discharge by students may not end before the end date.',
  minDate: 'The date must to be after {{date}}.',
  productImage: 'You have to upload a productimage.',
  number: 'The format of the number ist not allowed',
  oneWeekDayRequired: 'At least one weekday is required'
};

export default en;
